import { render, staticRenderFns } from "./selectAvatar.vue?vue&type=template&id=145c481e&scoped=true"
import script from "./selectAvatar.vue?vue&type=script&lang=js"
export * from "./selectAvatar.vue?vue&type=script&lang=js"
import style0 from "./selectAvatar.vue?vue&type=style&index=0&id=145c481e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c481e",
  null
  
)

export default component.exports